import { Icon, TextField } from "@platform/design-system";
import { Box, IconButton } from "@mui/material";

export interface ThreadSearchProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Filters the thread list by what the reader types.
 *
 * Filters the page already loaded rather than asking the service: the listing
 * RPC takes no search term, and the alternative — fetching every page to
 * search across them — is the unbounded read the cursor exists to prevent.
 * So this narrows what is on screen, and the clear affordance puts the full
 * page back.
 */
export const ThreadSearch = ({
  value,
  onChange,
}: ThreadSearchProps): React.JSX.Element => (
  <Box
    data-testid="thread-search"
    sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: "divider" }}
  >
    <TextField
      fullWidth
      size="sm"
      value={value}
      placeholder="Search messages & threads"
      inputProps={{ "aria-label": "Search messages and threads" }}
      onChange={(event) => onChange(event.target.value)}
      startAdornment={<Icon name="search" size="sm" />}
      endAdornment={
        value ? (
          <IconButton
            size="small"
            aria-label="Clear search"
            onClick={() => onChange("")}
          >
            <Icon name="close" size="sm" />
          </IconButton>
        ) : undefined
      }
    />
  </Box>
);
